<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { ROSACEA_GRADE_LEVELS, ROSACEA_SUBTYPE_OPTIONS } from '../types/rosacea-grade'

    export let data: Record<string, any>
</script>

<div class="rosacea-grade">
    {#each ROSACEA_SUBTYPE_OPTIONS as option (option.key)}
        <div class="rosacea-row" class:selected={option.key === '2'}>
            <span class="rosacea-label">
                {option.label} — {option.name}
                <span class="rosacea-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <select class="rosacea-select" disabled>
                <option>Selecione</option>
                {#each ROSACEA_GRADE_LEVELS as level (level)}
                    <option selected={option.key === '2' && level === 'Leve'}>{level}</option>
                {/each}
            </select>
        </div>
    {/each}
</div>

<style>
    .rosacea-grade {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .rosacea-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .rosacea-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .rosacea-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .rosacea-row.selected .rosacea-label {
        color: #1f2937;
    }
    .rosacea-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .rosacea-row.selected .rosacea-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
    .rosacea-select {
        /* Preview do bloco no construtor do modelo é sempre claro — sem isso, o Chromium renderiza
           a lista nativa de opções (popup do <select>) escura quando o tema do app é escuro. */
        color-scheme: light;
        flex-shrink: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 6px 8px;
        font-size: 0.82rem;
        color: #495057;
        background: #fff;
    }
    /* O select do preview é sempre `disabled`, e o css_global.css pinta todo `select:disabled` de
       escuro com `!important` — como a área do documento é sempre clara, anulamos aqui (mesma
       sobrescrita que rosacea-grade-view.svelte já faz no campo preenchível). */
    .rosacea-select:disabled {
        color: #495057 !important;
        background: #fff !important;
        border-color: #dee2e6 !important;
    }
</style>
